export default "__VITE_ASSET__RAk1eLl8__"